"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATN = void 0;
exports.ATN = {
    id: 'atn',
    companyName: 'All Transport Network',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'atn',
    },
    isInternal: false,
    isActive: true,
    countries: ['PH'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVROLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL0FUTi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLEdBQUcsR0FBVTtJQUN0QixFQUFFLEVBQUUsS0FBSztJQUNULFdBQVcsRUFBRSx1QkFBdUI7SUFDcEMsY0FBYyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3ZCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxLQUFLO0tBQ2Y7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=